// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { getProp } from "@insite/mobius/utilities";
import { floatingTooltipStyles } from "@sc/App/Components/FloatingTooltip/FloatingTooltip";
import { color, getSystemColor } from "@sc/XDL/Utilities";
import { css } from "styled-components";

floatingTooltipStyles.tooltipContent = {
    css: css`
        background-color: ${color("common.ui1")};
        z-index: ${getProp("theme.zIndex.tooltip")};
        box-shadow: 0 2px 4px 0 ${color("common.ui7", 0.1)};
        padding: 8px;
        border-radius: 4px;
        max-width: 250px;
    `,
};

floatingTooltipStyles.tooltipArrow = {
    width: 24,
    height: 16,
    fill: getSystemColor("common.ui9"),
    strokeWidth: 0,
};

floatingTooltipStyles.drawerContent = {
    css: css`
        background-color: ${color("common.ui1")};
        display: flex;
        position: fixed;
        flex-direction: column;
        right: -464px;
        top: 0;
        height: 100vh;

        width: 332px;
        z-index: ${getProp("theme.zIndex.drawer")};
        transition: right 0.5s ease-in-out;

        ${({ isMounted }: any) =>
            isMounted &&
            css`
                right: 0;
            `}
    `,
};

floatingTooltipStyles.drawerClose = {
    size: 10,
    color: "common.ui1",
    css: css`
        cursor: pointer;
        margin-left: auto;
        background-color: ${color("text.link", 0.77)};
        border-radius: 2px;
        padding: 4px;
        width: 18px;
        height: 18px;
        &:hover {
            background-color: ${color("text.link")};
        }
    `,
};
